import * as React from 'react';
import cn from 'classnames';

import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import { TranslationString } from 'shared/entities/localization';

import './HelperText.modules.scss';

type Props = {
  text: TranslationString;
  withContent?: boolean;
};

const HelperText: React.FC<Props> = ({ text, withContent }) => (
  <div styleName={cn('helper-text', withContent && 'helper-text_with-content')}>
    <Typography
      fontType={TypographyType.text}
      fontSize={TypographySize.s}
      fontColor={TypographyColor.secondary}
      fontWeight={TypographyWeight.normal}
    >
      {text}
    </Typography>
  </div>
);

export default React.memo(HelperText);
